<template>
	<LayoutList>
		<template slot="header">
			<h1>Intelligence</h1>
			<router-link to="/intelligence/create" class="btn btn--primary" v-if="can('createIntelligence')">
				Create
			</router-link>
		</template>
		<template slot="filters">
			<FormControlSector
                name="sectors"
                v-model="filters.sectors"
                :multiple="true"
                :include-ancestors="false"
            />
			<FormControlDealType
                name="deal_type"
                v-model="filters.deal_type"
            />
			<FormControlMember
                name="member"
                v-model="filters.member"
                placeholder="Select..."
                label="Member company"
            />
		</template>
		<div class="form__group search" slot="search">
			<label for="local-search" class="form__label">
                Search Intelligence
            </label>
			<input
                id="local-search"
                class="form__control search"
                type="search"
                placeholder="Search Intelligence..."
                v-model="filters.query"
            />
		</div>
		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="all" title="All Intelligence">
				<ListIntelligence
                    ref="all"
                    :load-on-start="false"
                    :filters="filters"
                />
			</v-tab>
			<v-tab id="mine" title="My Intelligence">
				<ListIntelligence
                    ref="mine"
                    :load-on-start="false"
                    :filters="filters"
                    :mine-only="true"
                />
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>

<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '../Layout/LayoutList';
	import ListIntelligence from '../List/ListIntelligence';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlDealType from '../Form/Control/FormControlDealType';
	import FormControlMember from '../Form/Control/FormControlMember';
	import TabbedPage from '../TabbedPage';
    import FiltersFromUrl from '../FiltersFromUrl';

    export default {
		name: 'IntelligenceList',
		mixins: [TabbedPage, FiltersFromUrl],
		components: {
			FormControlMember,
			FormControlDealType,
			FormControlSector,
			ListIntelligence,
			LayoutList,
		},
		data() {
			return {
				filters: {
					sectors: [],
					deal_type: null,
					member: null,
					query: null,
				},
				defaultTab: 'all',
				tabRoute: 'intelligence',
			}
		},
		computed: {
			...mapGetters([
				'can',
				'intelligence'
			]),
		},
		watch: {
			filters: {
				deep: true,
				handler() {
					this.$store.commit('modifyIntelligence', {
						query: this.filters.query,
						sectors: this.filters.sectors,
						deal_type: this.filters.deal_type,
						member_company: this.filters.member,
					});

                    this.$refs.all.resetPagination();
                    this.$refs.mine.resetPagination();
				}
			}
		},
		methods: {
			load() {
				this.filters.query = this.intelligence.query;
				this.filters.sectors = this.intelligence.sectors;
				this.filters.deal_type = this.intelligence.deal_type;
				this.filters.member = this.intelligence.member_company;
			},
		},
		created() {
			this.load();
		}
	}
</script>
